<div class="container">
  <h1 class="mt-3 text-white">Parcours Scolaire</h1>
  <div id="education" class="timeline">

    <h2 data-aos-duration="2100" data-aos="fade-down" class="timeline__item timeline__item--year text-white">2021</h2>

    <div data-aos-duration="2100" data-aos="fade-right" class="timeline__item text-white">
      <h3 class="timeline__title">
        Élève ingénieur en deuxième année filière système d'information & réseau informatique
      </h3>
      <a
        href="https://www.uca.ma/fstgm/fr/departement/informatique/irisi-ingenierie-en-reseaux-et-systemes-dinformation">
        IRISI</a>
      <h4>Faculté des Sciences et Techniques de Marrakech</h4>
    </div>

    <h2 data-aos-duration="2100" data-aos="fade-down" class="timeline__item timeline__item--year">2019</h2>

    <div data-aos-duration="2100" data-aos="fade-left" class="timeline__item text-white">
      <h3 class="timeline__title">Diplôme d'études universitaires scientifiques et techniques (DEUST) Informatique &
        Mathématiques
      </h3>
      <h4>Faculté des Sciences et Techniques de Marrakech</h4>
    </div>

    <h2 data-aos-duration="2100" data-aos="fade-down" class="timeline__item timeline__item--year">2017</h2>

    <div data-aos-duration="2100" data-aos="fade-right" class="timeline__item text-white">
      <h3 class="timeline__title">Baccalauréat en science physique</h3>
      <h4>Lycée Qualifiant Al Farahidi </h4>
    </div>

  </div>
</div>